import { type PropsWithChildren } from 'react';
import { cn } from '@/utils';
const SectionContainer = ({
  className,
  children
}: PropsWithChildren<{
  className?: string;
}>) => <section className={cn('flex flex-col gap-xs', className)} data-sentry-component="SectionContainer" data-sentry-source-file="Section.tsx">
    {children}
  </section>;
const SectionTitle = ({
  children
}: PropsWithChildren) => <h3 className="text-body-lg-bold text-neutral" data-sentry-component="SectionTitle" data-sentry-source-file="Section.tsx">{children}</h3>;
const SectionCardContainer = ({
  className,
  children
}: PropsWithChildren<{
  className?: string;
}>) => <article className={cn('rounded-md bg-white p-lg shadow-sm border border-alternative', className)} data-sentry-component="SectionCardContainer" data-sentry-source-file="Section.tsx">
    {children}
  </article>;
export const Section = {
  Container: SectionContainer,
  Title: SectionTitle,
  CardContainer: SectionCardContainer
};